module.exports = __webpack_public_path__ + "static/media/TT Commons Trial DemiBold.5de45704.otf";